import React, { useState } from 'react';
import {
  Paper,
  Box,
  Button,
  Typography,
  Link
} from '@mui/material';
import { useCookieConsent } from '../hooks/useCookieConsent';
import CookieSettings from './CookieSettings';

/**
 * Cookie consent banner component
 * Displays a banner at the bottom of the page for cookie consent
 */
const CookieBanner = () => {
  const { isLoaded, hasConsent, acceptAll, rejectOptional } = useCookieConsent();
  const [showSettings, setShowSettings] = useState(false);

  // Don't show banner if consent is already given or not loaded yet
  if (!isLoaded || hasConsent) {
    return null;
  }

  const handleAcceptAll = () => {
    acceptAll();
  };

  const handleRejectOptional = () => {
    rejectOptional();
  };

  const handleOpenSettings = () => {
    setShowSettings(true);
  };

  const handleCloseSettings = () => {
    setShowSettings(false);
  };

  return (
    <>
      <Paper
        elevation={8}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          p: 2,
          borderRadius: 0,
          bgcolor: 'background.paper',
          borderTop: 1,
          borderColor: 'divider',
          animation: 'fadeIn 0.3s ease-in'
        }}
      >
        <Box
          sx={{
            maxWidth: '1200px',
            mx: 'auto',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: 2
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="body1" component="p" sx={{ mb: 1 }}>
              Ta strona używa plików cookie, aby zapewnić najlepsze doświadczenie użytkownika.
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Używamy plików cookie niezbędnych do działania strony oraz opcjonalnych do analityki i marketingu.
              Możesz zarządzać preferencjami w każdej chwili.{' '}
              <Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenSettings();
                }}
                sx={{ textDecoration: 'underline' }}
              >
                Więcej informacji
              </Link>
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 1,
              flexShrink: 0
            }}
          >
            <Button
              variant="outlined"
              size="small"
              onClick={handleRejectOptional}
              sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
            >
              Odrzuć opcjonalne
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleOpenSettings}
              sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
            >
              Ustawienia
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleAcceptAll}
              sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
            >
              Akceptuj wszystkie
            </Button>
          </Box>
        </Box>
      </Paper>
      <CookieSettings open={showSettings} onClose={handleCloseSettings} />
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default CookieBanner;

